'use client'
import React from 'react'
import { TitleDivider } from 'components/TitleDivider'
import { VideoPlayer } from 'components/VideoPlayer'
import { useMemoizedContentGetter } from 'utils/contentful'
import Section, { SECTION_VARIANTS } from 'components/Section'
import { Typography } from 'components/Contentful'
import { StatGrid } from 'components/StatGrid'
import classNames from 'classnames'
import EmailCta from 'utils/EmailCta'

import { SITE_ENVIRONMENTS } from 'constants/websites'
function AboutUsVideo({ content }) {
  const {
    eyebrow,
    title,
    subtitle,
    disclaimer,
    videoPlayer,
    grid,
    config,
    backgroundConfig,
    emailCta,
  } = useMemoizedContentGetter(content, [
    'eyebrow',
    'title',
    'subtitle',
    'disclaimer',
    'videoPlayer',
    'grid',
    'config',
    'backgroundConfig',
    'emailCta',
  ])
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'

  const variantBg = config?.jsonContent?.sectionVariant ?? SECTION_VARIANTS.bgPrimaryHighlightBlue
  const id = config?.jsonContent?.id ?? 'about-us-video'
  const subtitleTag = config?.jsonContent?.subtitleTag ?? 'h3'
  const eyebrowColor = config?.jsonContent?.eyebrownColor
  return (
    <Section
      className={'overflow-hidden px-0 py-12 lg:px-0 lg:py-16'}
      fullBackground={backgroundConfig?.jsonContent?.fullBackground ?? false}
      variant={variantBg}
      data-testid="AboutUsVideo_section"
      id={id}
    >
      <TitleDivider
        eyebrowClassName={`${
          eyebrowColor ? eyebrowColor : eyebrow?.fontColor
        } font-bold tracking-eyebrow`}
        eyebrowBlack={variantBg !== SECTION_VARIANTS.bgBlue100}
        title={title}
        eyebrow={eyebrow}
        subtitle={grid ? null : subtitle}
        subtitleTag={subtitleTag}
        classNameTitleText="headingMd lg:displayLg font-medium!"
        classNameSubtitleText="bodySm lg:displaySm font-light! [&>a]:font-bold!"
        className={emailCta && 'mb-8'}
      />
      {emailCta && <EmailCta emailCta={emailCta} />}
      <VideoPlayer content={videoPlayer} aspectRatio={16 / 9} />
      {grid && <StatGrid grid={grid} />}
      {disclaimer && (
        <Typography
          data-testid="title-divider-disclaimer"
          className={classNames(
            'max-w-[808px] text-center text-[#42546b] m-auto pt-12',
            siteEnv === SITE_ENVIRONMENTS.FDR ? 'bodyXs' : ''
          )}
          content={disclaimer.textContent}
        />
      )}
    </Section>
  )
}
export { AboutUsVideo }
export default AboutUsVideo
